import List from './List';
import Create from './Create';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'job_billings',
  inputShow: gql`
    query jobBillings($input: JobBillingQueryInput) {
      jobBillings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Job Billings',
  },
};
